var angular = require('angular');
var _module = require('./index');

require('angular-material');
require('../lr-touch');
require('../cached-templates/templates');

_module.requires.push('lr.touch', 'ngMaterial', 'templates');


_module
    .directive('simpleDialog', [
        '$timeout',
        '$rootScope',

        function($timeout, $rootScope) {
            var ANIMATION_START_EVENTS = 'animationstart webkitAnimationStart oanimationstart MSAnimationStart';
            var ANIMATION_END_EVENTS = 'animationend webkitAnimationEnd oanimationend MSAnimationEnd';

            return {
                restrict: 'E',
                replace: true,
                transclude: true,
                scope: {
                    '$show': '=show',
                    'onShow': '&',
                    'onHide': '&',
                    'onShowFinished': '&',
                    'onHideFinished': '&'
                },
                templateUrl: 'js/components/core/templates/simple-dialog.tmpl.html',
                link: function($scope, elem, attrs) {
                    console.log('Simple Dialog');

                    $scope.$showContent = false;

                    // $scope Functions
                    $scope.$hideDialog = function($event) {
                        $scope.$show = false;
                        $event.preventDefault();
                        $event.stopPropagation();                        
                    };

                    // $watch Functions
                    $scope.$watch('$show', function(newValue) {
                        if(newValue) {
                            angular.element('body').addClass('simple-dialog-open');
                            $scope.onShow();
                            $scope.$showContent = true;
                            $rootScope.$broadcast('SimpleDialogEvent:ShowingDialog');
                        }
                        else {
                            angular.element('body').removeClass('simple-dialog-open');
                            $scope.onHide();
                            $rootScope.$broadcast('SimpleDialogEvent:HidingDialog');
                        }
                    });

                    // Event Listeners
                    elem.on(ANIMATION_START_EVENTS, function() {
                        if($scope.$show) {
                            $scope.$apply(function() {
                                $rootScope.$broadcast('SimpleDialogEvent:AnimationInStarted');
                            });
                        } else {
                            $scope.$apply(function() {
                                $rootScope.$broadcast('SimpleDialogEvent:AnimationOutStarted');
                            });
                        }
                    });

                    elem.on(ANIMATION_END_EVENTS, function() {
                        if($scope.$show) {
                            $scope.$apply(function() {
                                $scope.onShowFinished();
                                $rootScope.$broadcast('SimpleDialogEvent:AnimationInEnded');
                            });
                        } else {
                            $scope.$apply(function() {
                                $scope.onHideFinished();
                                $rootScope.$broadcast('SimpleDialogEvent:AnimationOutEnded');
                                $scope.$showContent = false;
                            });
                        }
                    });
                }
            };
        }
    ])
;
